// @flow

import { makeApiCall } from '../../../../../services/apiService/apiService';

export const incompleteCnDashboardActions = {
  GET_DASHBOARD_DATA: 'GET_DASHBOARD_DATA',
  GET_EXPECTED_ARRIVALS_COUNT: 'GET_EXPECTED_ARRIVALS_COUNT',
  FILTER_DASHBOARD_DATA: 'FILTER_INCOMPLETE_CN_DASHBOARD_DATA'
};

export const getDashboardDataAction = (load: Object) => ({
  type: incompleteCnDashboardActions.GET_DASHBOARD_DATA,
  payload: load
});

export const getExpectedArrivalsAction = (load: Object) => ({
  type: incompleteCnDashboardActions.GET_EXPECTED_ARRIVALS_COUNT,
  payload: load
});
export const filterDashboardData = (load: Object) => ({
  type: incompleteCnDashboardActions.FILTER_DASHBOARD_DATA,
  payload: load
});

function getDashboardFailurePayload(dispatch, res) {
  dispatch(
    getDashboardDataAction({
      isLoading: false,
      isLoaded: true,
      dashboardData: [],
      dashboardDataFiltered: [],
      error: res.errorMessage || 'Could not fetch Incomplete CNs'
    })
  );
}

function getExpectedArrivalsFailurePayload(dispatch) {
  dispatch(
    getExpectedArrivalsAction({
      count: []
    })
  );
}

export const getExpectedArrivalsCount = () => (dispatch: Function) => {
  dispatch(getExpectedArrivalsAction({ count: [] }));
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getExpectedArrivalsCount',
    method: 'GET',
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(getExpectedArrivalsAction({ count: res.payload }));
      } else {
        getExpectedArrivalsFailurePayload(dispatch);
      }
    },
    failureCb: () => {
      getExpectedArrivalsFailurePayload(dispatch);
    },
    catchCb: () => {
      getExpectedArrivalsFailurePayload(dispatch);
    }
  };
  return makeApiCall(requestObj);
};

export const getDashboardData = () => (dispatch: Function) => {
  dispatch(
    getDashboardDataAction({
      isLoading: true,
      isLoaded: false,
      dashboardData: [],
      dashboardDataFiltered: [],
      error: null,
      result: []
    })
  );
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getIncompleteCnList',
    method: 'GET',
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          getDashboardDataAction({
            isLoading: false,
            isLoaded: true,
            dashboardData: res.payload || [],
            dashboardDataFiltered: res.payload || [],
            error: null
          })
        );
      } else {
        getDashboardFailurePayload(dispatch, res);
      }
    },
    failureCb: res => {
      getDashboardFailurePayload(dispatch, res);
    },
    catchCb: res => {
      getDashboardFailurePayload(dispatch, res);
    }
  };

  return makeApiCall(requestObj);
};
